import QRContainer from './qr-data.container';

export default QRContainer;